import FakeStorage from 'fa-storage/src/memory.js'

const allowedStorages = [
  'state',
  '_canWriteToLocalStorage',
  'ga:clientId',
  'cacheUrl',
  'counter',
  '@@'
]

function isLocalStorageSupported() {
  const item = `localStoragePollyfill`
  try {
    localStorage.setItem(item, item)
    localStorage.removeItem(item)
    return true
  } catch (e) {
    return false
  }
}

const nativeStorage = new FakeStorage()

nativeStorage._setItem = nativeStorage.setItem
nativeStorage._getItem = nativeStorage.getItem
nativeStorage._removeItem = nativeStorage.removeItem
nativeStorage._clear = nativeStorage.clear

const storageOperations = []
const updateNativeStorage = (action, key, item) => {
  const error = e => {
    throw e
  }
  // alert(`updateNativeStorage ${action} ${key} ${item}`) // eslint-disable-line
  storageOperations.push({ action, key, item })
  const update = () => {
    // alert('updateNative '+ storageOperations.length) // eslint-disable-line
    if (storageOperations.length === 0) return
    const { action, key, item } = storageOperations.pop()
    switch (action) {
      case 'setItem':
        window.NativeStorage.setItem(key, item, update, error)
        break
      case 'removeItem':
        window.NativeStorage.remove(key, update, error)
        break
      case 'clear':
        window.NativeStorage.clear(update, error)
        break
      default:
        throw new Error('unknown storage action')
    }
  }
  update()
}

nativeStorage.setItem = (key, item) => {
  if (allowedStorages.indexOf(key) === -1) console.error(`attempted to write to unknown key: '${key}'`)
  updateNativeStorage('setItem', key, item)
  return nativeStorage._setItem(key, item)
}
nativeStorage.getItem = key => {
  return nativeStorage._getItem(key)
}
nativeStorage.removeItem = key => {
  updateNativeStorage('removeItem', key)
  return nativeStorage._removeItem(key)
}
nativeStorage.clear = () => {
  updateNativeStorage('clear')
  return nativeStorage._clear()
}

nativeStorage._init = (err, callback) => {
  window.NativeStorage.keys(keys => {
    const sync = () => {
      if (keys.length === 0) return callback()
      const key = keys.pop()
      if (allowedStorages.indexOf(key) === -1) return sync()
      window.NativeStorage.getItem(key, item => {
        // alert('item ' + key + ' ' + typeof item)  // eslint-disable-line
        nativeStorage._setItem(key, item)
        sync()
      }, err)
    }
    sync()
  }, err)
}

export let storage = {}

const initCordova = (err, callback) => {
  storage = nativeStorage
  nativeStorage._init(err, () => {
    // transfert form old storage
    Object.keys(window.localStorage).forEach(key => storage.setItem(key, window.localStorage[key]))
    window.localStorage.clear()
    // alert('_init ok') // eslint-disable-line
    callback()
  })
}

const initBrowser = (err, callback) => { // eslint-disable-line
  if (isLocalStorageSupported()) {
    storage = window.localStorage
  } else {
    const iOS = /iP(ad|hone|od).+Version\/[\d.]+.*Safari/i.test(navigator.userAgent)
    const errorMessage = 'Votre naviguateur bloque la sauvegarde locale (cookies). Les favoris et la mémorisation des paramètres ne fonctionneront pas.\n\nYour navigator denies local storage (cookies). Favorites and settings persistence will not work.'
    let iOSMessage = ''
    if (iOS) {
      iOSMessage = '\n\n(Settings / Réglages -> Safari ->  Cookies)'
    }
    alert(errorMessage + iOSMessage) // eslint-disable-line no-alert
    storage = new FakeStorage()
  }

  callback()
}

export const initStorage = (err, callback) => {
  if ('cordova' in window) {
    initCordova(err, callback)
  } else {
    initBrowser(err, callback)
  }
}



// WEBPACK FOOTER //
// ./src/assets/storage.js